import { ref, runTransaction } from 'firebase/database';
import { database } from './firebaseConfig';

/**
 * Display baselines applied on top of the actual RTDB counters so the page
 * starts from realistic numbers without seeding the database. The cleanup
 * function only removes /rooms, so /stats persists across daily resets.
 */
export const BASELINE_USERS = 358;
export const BASELINE_ROOMS = 72;

export type StatField = 'totalUsers' | 'totalRooms';

export async function incrementStat(field: StatField): Promise<void> {
  try {
    const r = ref(database, `stats/${field}`);
    await runTransaction(r, current => (typeof current === 'number' ? current : 0) + 1);
  } catch {
    // Counter writes are best-effort. If the security rules block /stats
    // writes, the displayed value falls back to the baseline.
  }
}
